export default __webpack_public_path__ + "2fff9285784349f4f8831a15529a825c.svg";